import { render, staticRenderFns } from "./OrderIcon.vue?vue&type=template&id=37863d56"
import script from "./OrderIcon.vue?vue&type=script&lang=js"
export * from "./OrderIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports